var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tz_box"},[_c('Tabs',{attrs:{"value":"name1"}},[_c('Tab-pane',{attrs:{"label":"优秀项目负责人","name":"name1"}},[_c('div',{staticClass:"cell_box"})])],1),_c('ksLogin',{ref:"ksbox"}),_c('detailModal',{ref:"detailModal"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }